module.exports = __webpack_public_path__ + "static/4-e4a38c67e9051d378cc441113289d23b.woff";